var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarSimilarCars = function SvgCarSimilarCars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.305 2h11.39L19 8.059V15H1V8.059L4.305 2Zm.89 1.5L2.5 8.441V13.5h15V8.441L14.805 3.5h-9.61Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11A1.25 1.25 0 1 1 4 11a1.25 1.25 0 0 1 2.5 0ZM15.5 11a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM1 13.75h3v4H1v-4ZM16 13.75h3v4h-3v-4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5H2V7h16v1.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.995h2.5v1.51H0v-1.51ZM17.75 5.995h2.5v1.51h-2.5v-1.51Z",
    fill: "currentColor"
  })));
};
export default SvgCarSimilarCars;